import React from 'react'
import {Row, Col} from 'react-flexbox-grid'
import _ from 'lodash'

import {Button, Icon, Menu, Modal} from 'antd'

import {Link} from 'react-router'

import {DevicesStorage} from 'storage'
import {DeviceStore} from 'api/device'

import {DeviceTable, SortTypes} from './DeviceTable.jsx'
import {DeviceFacets} from './DeviceFacets.jsx'
import {CreateDevice} from './CreateDevice.jsx'

export class DeviceManagement extends React.Component {
   static get propTypes() {
      return {
         network:  React.PropTypes.object.isRequired,
         params:   React.PropTypes.object.isRequired,
         router:   React.PropTypes.object.isRequired,
         location: React.PropTypes.object.isRequired
      }
   }

   static get defaultProps() {
      return {
         network: {}
      }
   }

   constructor(props) {
      super(props)

      this.state = {
         view:        'table',
         filter:      null,
         aside:       true,
         deviceModal: false,
         sorting:     [
            _.get(props.location.query, 'sort.column', 'meta.created'),
            _.get(props.location.query, 'sort.order', SortTypes.DEFAULT)
         ],
         columns: _.get(
            props.location.query,
            'columns',
            'key,name,address,type,proto/tm.firmware,proto/tm.hardware,meta.event/date',
         ).split(',')
      }

      this.updateFacets = this.updateFacets.bind(this)
      this.updateColumns = this.updateColumns.bind(this)
      this.toggleAside = this.toggleAside.bind(this)
      this.toggleDeviceModal = this.toggleDeviceModal.bind(this)

      this.onToggleColumn = this.onToggleColumn.bind(this)
      this.onSortChange = this.onSortChange.bind(this)
   }

   updateFacets(filter) {
      this.setState({filter})
   }

   updateColumns(columns) {
      const {router, location} = this.props,
         callback = () => {
            router.replace({
               ...location,
               query: _.set(location.query, 'columns', this.state.columns.join(','))
            })
         }

      if (!_.isArray(columns)) {
         this.setState({columns: columns.split(',')}, callback)
      } else {
         this.setState({columns}, callback)
      }
   }

   onToggleColumn(column) {
      this.setState(state => _.set(state, 'columns', _.without(state.columns, column)))
   }

   onSortChange(field, dir) {
      const {router, location} = this.props

      this.setState({sorting: [field, dir]}, () => {
         let query = _.merge(location.query, {
            'sort.column': field,
            'sort.order':  dir
         })

         router.replace({...location, query})
      })
   }

   setViewTable() {
      this.setState({view: 'table'})
   }

   setViewMap() {
      this.setState({view: 'map'})
   }

   toggleAside() {
      this.setState(state => _.set(state, 'aside', !state.aside))
   }

   toggleDeviceModal() {
      this.setState(state => _.set(state, 'deviceModal', !state.deviceModal))
   }

   render() {
      let {network, params, location} = this.props,
         {aside, filter, columns, sorting} = this.state,
         basepath = _.dropRightWhile(location.pathname.split('/'), p => 'create' === p).join('/')

      return (
         <Row>
            <Col xs={4} style={{display: aside ? 'initial' : 'none'}}>
               <DevicesStorage filter={filter} nid={params.nid}>
                  <DeviceFacets
                     onChange={this.updateFacets}
                     onColumnsUpdate={this.updateColumns}
                     columns={columns}
                     availableColumns={_.map(DeviceStore.columns, label => {
                        return {label, value: label}
                     })}
                     {...this.props}
                  />
               </DevicesStorage>

               <div className="actions">
                  <Menu selectedKeys={this.props.children ? ['create'] : []}>
                     <Menu.Item key="create">
                        <Link to={{...location, pathname: basepath + '/create'}}>
                           <Icon type="plus" /> Create new Device
                        </Link>
                     </Menu.Item>
                     <Menu.Item>
                        <a onClick={this.toggleAside}><Icon type="menu-fold" /> Hide Sidebar</a>
                     </Menu.Item>
                     {this.props.children
                        ? <Menu.Item>
                             <Link to={{...location, pathname: basepath}}>
                                <Icon type="rollback" /> Go Back
                             </Link>
                          </Menu.Item>
                        : null}
                  </Menu>
               </div>
            </Col>

            <Col xs={aside ? 8 : 12}>
               {this.props.children
                  ? React.cloneElement(this.props.children, {network, params, location})
                  : <DeviceTable
                       columns={this.state.columns}
                       rescan={aside}
                       filter={filter}
                       onToggleColumn={this.onToggleColumn}
                       onSortChange={this.onSortChange}
                       sorting={sorting}
                       {...this.props}
                    />}

               {aside
                  ? null
                  : <Menu selectedKeys={['noop']}>
                       <Menu.Item>
                          <a onClick={this.toggleAside}><Icon type="menu-unfold" /> Show Sidebar</a>
                       </Menu.Item>
                    </Menu>}
            </Col>
         </Row>
      )
   }
}

DeviceManagement.childRoutes = [
   {
      name:        'Create Device',
      glyph:       'plus',
      path:        'create',
      component:   CreateDevice,
      childRoutes: CreateDevice.childRoutes
   }
]



// WEBPACK FOOTER //
// lib/bundle/dashboard/network/device-manager/index.js